/**
 * 모델
 * @window w_tb_e401w_recvscore
 * @category 고장처리고객만족도
 */
import { computed } from 'mobx';

export class BreakCustomerModel {
  /**
   * 회사코드
   *
   * **data type** varchar(8)
   */
  readonly custcd: string;

  /**
   * 사업장코드
   *
   * **data type** varchar(2)
   */
  readonly spjangcd: string;

  /**
   * 전송결과
   *
   * **data type** varchar(13)
   */
  result_code: string;

  /**
   * 회사
   *
   * **data type** varchar(13)
   */
  wkactcd: string;

  /**
   * 현장코드
   *
   * **data type** varchar(15)
   */
  actcd: string;

  /**
   * 현장명
   *
   * **data type** varchar(100)
   */
  actnm: string;

  /**
   * 호기명
   *
   * **data type** varchar(2)
   */
  equpnm: string;

  /**
   * 승강기번호
   *
   * **data type** varchar(10)
   */
  elno: string;

  /**
   * 점검자
   *
   * **data type** float
   */
  kcpernm: string;

  /**
   * 계획일자
   *
   * **data type** varchar(20)
   */
  plandate: string;

  /**
   * 점검일자
   *
   * **data type** varchar(20)
   */
  rptdate: string;

  /**
   * 전송일자
   *
   * **data type** char(1)
   */
  senddate: string;

  /**
   * 전송시간
   *
   * **data type** varchar(50)
   */
  sendtime: string;

  /**
   * 차이일
   *
   * **data type** varchar(6)
   */
  gigan: string;

  /**
   * 전송실패내용
   *
   * **data type** varchar(?)
   */
  error_message: string;

  /**
   * 하단 총계 데이터
   *
   * **data type** varchar(?)
   */
  equp_cnttot: string;

  /**
   * 하단 총계 데이터
   *
   * **data type** varchar(?)
   */
  recetelnum: string;

  /**
   * 처리자
   *
   * **data type** varchar(?)
   */
  pernm: string;

  /**
   * 처리자2
   *
   * **data type** varchar(?)
   */
  pernm2: string;

  /**
   * 고객만족도
   *
   * **data type** varchar(?)
   */
  recvmsg: string;

  /**
   * 선택
   *
   * **data type** varchar(?)
   */
  chk: string;

  /**
   * 신고자번호
   *
   * **data type** varchar(?)
   */
  hp: string;

  /**
   * 담당자휴대폰번호
   *
   * **data type** varchar(?)
   */
  acthp: string;

  /**
   * 모름
   *
   * **data type** varchar(?)
   */
  recedate: string;

  /**
   * 모름
   *
   * **data type** varchar(?)
   */
  recenum: string;

  /**
   * 신규인지
   *
   * **data type** varchar(1)
   */
  new: string;

  constructor(data: any = {}, isNew: boolean = false) {
    this.custcd = data.custcd || '';
    this.spjangcd = data.spjangcd || '';
    this.actcd = data.actcd || '';
    this.actnm = data.actnm || '';
    this.equpnm = data.equpnm || '';
    this.result_code = data.result_code || '';
    this.wkactcd = data.wkactcd || '';
    this.actnm = data.actnm || '';
    this.pernm = data.pernm || '';
    this.pernm2 = data.pernm2 || '';
    this.equpnm = data.equpnm || '';
    this.elno = data.elno || '';
    this.kcpernm = data.kcpernm || '';
    this.plandate = data.plandate || '';
    this.rptdate = data.rptdate || '';
    this.senddate = data.senddate || '';
    this.sendtime = data.sendtime || '';
    this.gigan = data.gigan || '';
    this.error_message = data.error_message || '';
    this.equp_cnttot = data.equp_cnttot || '';
    this.recetelnum = data.recetelnum || '';
    this.recedate = data.recedate || '';
    this.recenum = data.recenum || '';
    this.recvmsg = data.recvmsg || '';
    this.chk = data.chk || '';
    this.hp = data.hp || '';
    this.acthp = data.acthp || '';
    this.new = isNew ? '1' : '0';
  }

  @computed
  get isNew() {
    return this.new === '1';
  }
}
